export const getFontFaceStyles = (): string => /* scss */`
    /* Open Sans - Regular v18 vietnamese_latin-ext_latin_greek-ext_greek_cyrillic-ext_cyrillic */
    @font-face {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 400;
        src: url('https://cdn.ux.deere.com/brand-foundations/1.3.1/typography/open-sans-v18-regular.woff2') format('woff2'),
                url('https://cdn.ux.deere.com/brand-foundations/1.3.1/typography/open-sans-v18-regular.woff') format('woff')
    }

    /* Open Sans - Semibold v18 vietnamese_latin-ext_latin_greek-ext_greek_cyrillic-ext_cyrillic */
    @font-face {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 600;
        src: url('https://cdn.ux.deere.com/brand-foundations/1.3.1/typography/open-sans-v18-600.woff2') format('woff2'),
                url('https://cdn.ux.deere.com/brand-foundations/1.3.1/typography/open-sans-v18-600.woff') format('woff')
    }

    /* Open Sans - Bold v18 vietnamese_latin-ext_latin_greek-ext_greek_cyrillic-ext_cyrillic */
    @font-face {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        src: url('https://cdn.ux.deere.com/brand-foundations/1.3.1/typography/open-sans-v18-700.woff2') format('woff2'),
                url('https://cdn.ux.deere.com/brand-foundations/1.3.1/typography/open-sans-v18-700.woff') format('woff')
    }

    /* JDSansPro - Medium */
    @font-face {
        font-family: 'JDSansPro-Medium';
        font-style: normal;
        font-weight: normal;
        src: url('https://cdn.ux.deere.com/brand-foundations/1.3.1/typography/JDSansPro-Medium.woff2') format('woff2'),
            url('https://cdn.ux.deere.com/brand-foundations/1.3.1/typography/JDSansPro-Medium.woff') format('woff')
    }
`;
